'use es6';

import { Map as ImmutableMap } from 'immutable';
import createForm from 'forms-utils-lib/formDefinition/utils/createForm';
import PostSubmissionOptions from 'forms-utils-lib/constants/formDefinition/PostSubmissionOptions';
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as UpdateState from 'FormsUI/lib/UpdateState';
import * as Actions from 'FormsUI/actions/FormDefinition';
import * as FormCreationActions from 'FormsUI/actions/formCreation/formCreationActions';
import * as ActionsDragDrop from 'FormsUI/actions/FormDragDrop';
import * as ActionsSaving from 'FormsUI/actions/FormSaving';
import * as ActionsInvalidName from 'FormsUI/actions/FormInvalidName';
import { TabValidationsKeys } from 'FormsUI/constants/FormFieldValidations';
import PublishState from 'FormsUI/constants/PublishState';
import * as PublishedStates from 'FormsUI/constants/PublishedStates';
import { LIFECYCLESTAGE } from 'FormsUI/constants/SelectedExternalOptions';
import { UPDATE_LIFECYCLE_STAGE } from 'FormsUI/actions/FormDefinition/updateLifecycleStage';
import { SUCCEED_FORM_TRANSLATION } from 'FormsUI/actions/FormDefinition/translateFormDefinition';
import hydrateFormWithDefaults from 'FormsUI/utils/formDefinition/hydrateFormWithDefaults';
const INIT_VALIDATIONS = {
  [TabValidationsKeys.FORM]: {},
  [TabValidationsKeys.OPTIONS]: {},
  [TabValidationsKeys.PREVIEW]: {},
  [TabValidationsKeys.NAVIGATION]: {},
  [TabValidationsKeys.AUTOMATION]: {}
};
const INIT_STATE = {
  formPublishState: PublishState.PUBLISHED,
  definition: createForm({}),
  publishedForm: createForm({}),
  lastFetched: null,
  lastPublishState: PublishedStates.PUBLISHED,
  requestState: RequestState.NOT_REQUESTED,
  updateState: UpdateState.NOT_UPDATED,
  updateErrors: {},
  validation: Object.assign({}, INIT_VALIDATIONS),
  invalidProperty: {},
  styleAndPreview: new ImmutableMap({
    theme: true,
    style: false,
    test: false,
    pagination: false
  })
};
export function formDefinition(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_FORM_DEFINITION:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_FORM_DEFINITION:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_FORM_DEFINITION:
      return Object.assign({}, state, {
        formPublishState: action.formPublishState,
        definition: createForm(action.definition),
        originalDefinition: Object.assign({}, createForm(action.definition)),
        postSubmissionOption: action.definition.redirect ? PostSubmissionOptions.REDIRECT_PAGE : PostSubmissionOptions.THANK_YOU_MESSAGE,
        originalPostSubmissionOption: action.definition.redirect ? PostSubmissionOptions.REDIRECT_PAGE : PostSubmissionOptions.THANK_YOU_MESSAGE,
        updateState: state.updateState !== UpdateState.HAS_UPDATED ? state.updateState : UpdateState.NOT_UPDATED,
        // reset updateState if needed
        lastFetched: action.meta.timestamp,
        validation: Object.assign({}, INIT_VALIDATIONS),
        publishedForm: createForm(action.publishedForm)
      });
    case FormCreationActions.RESET_FORM_CREATION_STATE:
      return Object.assign({}, state, {
        updateState: UpdateState.NOT_UPDATED //reset the state
      });
    case Actions.FAIL_GETTING_FORM_DEFINITION:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED.setMessage(action.reason)
      });
    case Actions.UPDATE_FORM_VALUE:
      {
        return Object.assign({}, state, {
          definition: Object.assign({}, state.definition, action.payload),
          updateState: UpdateState.HAS_UPDATED
        });
      }
    case Actions.UPDATE_FORM_VALUE_SIMPLE:
      {
        return Object.assign({}, state, {
          definition: Object.assign(state.definition, action.updatedValue)
        });
      }
    case UPDATE_LIFECYCLE_STAGE:
      return Object.assign({}, state, {
        definition: Object.assign({}, state.definition, {
          selectedExternalOptions: [...state.definition.selectedExternalOptions.filter(({
            propertyName
          }) => propertyName.toLowerCase() !== LIFECYCLESTAGE), ...(action.payload ? [{
            referenceType: 'PIPELINE_STAGE',
            objectTypeId: '0-1',
            propertyName: LIFECYCLESTAGE,
            id: action.payload
          }, {
            referenceType: 'PIPELINE_STAGE',
            objectTypeId: '0-2',
            propertyName: LIFECYCLESTAGE,
            id: action.payload
          }] : [])]
        }),
        updateState: UpdateState.HAS_UPDATED
      });
    case SUCCEED_FORM_TRANSLATION:
      return Object.assign({}, state, {
        definition: createForm(hydrateFormWithDefaults(action.payload)),
        updateState: UpdateState.HAS_UPDATED
      });
    case Actions.UPDATE_POST_SUBMISSION_OPTION:
      return Object.assign({}, state, {
        postSubmissionOption: action.updatedOption,
        updateState: UpdateState.HAS_UPDATED
      });
    case Actions.UPDATE_FORM_FIELD:
    case Actions.UPDATE_FORM_FIELD_GROUP:
    case ActionsDragDrop.ADD_NEW_FORM_FIELD:
    case ActionsDragDrop.ADD_NEW_FORM_FIELD_GROUP:
    case ActionsDragDrop.REMOVE_FORM_FIELD:
    case ActionsDragDrop.REORDER_FORM_FIELD:
    case ActionsDragDrop.ADD_NEW_RICH_TEXT:
    case ActionsDragDrop.REMOVE_RICH_TEXT:
    case ActionsDragDrop.REORDER_RICH_TEXT:
      {
        return Object.assign({}, state, {
          definition: Object.assign({}, state.definition, {
            formFieldGroups: action.formFieldGroups
          }),
          updateState: UpdateState.HAS_UPDATED,
          showHighlightAnimation: false
        });
      }
    case ActionsDragDrop.APPEND_NEW_FORM_FIELD_GROUP:
      {
        return Object.assign({}, state, {
          definition: Object.assign({}, state.definition, {
            formFieldGroups: action.formFieldGroups
          }),
          updateState: UpdateState.HAS_UPDATED,
          animationMap: action.animationMap
        });
      }
    case ActionsSaving.SAVE_FORM:
      return Object.assign({}, state, {
        updateState: UpdateState.SAVING
      });
    case ActionsSaving.PUBLISH_FORM:
      return Object.assign({}, state, {
        updateState: UpdateState.PUBLISHING,
        updateErrors: {}
      });
    case ActionsSaving.SAVE_FORM_SUCCESS:
      return Object.assign({}, state, {
        definition: Object.assign({}, state.definition, Object.assign({}, action.updatedAt && {
          updatedAt: action.updatedAt,
          internalUpdatedAt: action.updatedAt
        })),
        formPublishState: PublishState.PUBLISHED_WITH_DRAFT,
        updateState: UpdateState.SAVING_SUCCEEDED,
        originalDefinition: Object.assign({}, state.definition),
        originalPostSubmissionOption: state.postSubmissionOption,
        invalidProperty: {},
        updateErrors: {}
      });
    case ActionsSaving.UPDATE_PUBLISH_UPDATE_DATE:
      return Object.assign({}, state, {
        publishedForm: Object.assign({}, state.publishedForm, {
          updatedAt: action.updatedAt,
          internalUpdatedAt: action.internalUpdatedAt
        }),
        definition: Object.assign({}, state.definition, {
          updatedAt: action.updatedAt,
          internalUpdatedAt: action.internalUpdatedAt
        })
      });
    case ActionsSaving.PUBLISH_FORM_SUCCESS:
      return Object.assign({}, state, {
        definition: createForm(action.definition),
        formPublishState: PublishState.PUBLISHED,
        lastPublishState: state.definition.isPublished ? PublishedStates.UPDATED : PublishedStates.PUBLISHED,
        updateState: UpdateState.SAVING_SUCCEEDED,
        originalDefinition: Object.assign({}, state.definition),
        originalPostSubmissionOption: state.postSubmissionOption,
        publishedForm: state.definition,
        invalidProperty: {}
      });
    case ActionsSaving.SAVE_FORM_ERROR:
    case ActionsSaving.PUBLISH_FORM_ERROR:
      return Object.assign({}, state, {
        updateState: UpdateState.SAVING_HAS_ERROR,
        updateErrors: action.errors
      });
    case ActionsInvalidName.INVALID_PROPERTY_NAME_ERROR:
      return Object.assign({}, state, {
        invalidProperty: Object.assign({}, action)
      });
    case Actions.ADD_VALIDATION_ERROR:
    case Actions.REMOVE_VALIDATION_ERROR:
      return Object.assign({}, state, {
        validation: action.payload
      });
    case Actions.TOGGLE_STYLE_SIDE_PANEL:
      return Object.assign({}, state, {
        styleAndPreview: state.styleAndPreview.update(action.section, val => !val)
      });
    case Actions.RESET_STYLE_PANEL:
      return Object.assign({}, state, {
        styleAndPreview: INIT_STATE.styleAndPreview
      });
    case Actions.RESET_FORM_DEFINITION:
      return INIT_STATE;
    default:
      return state;
  }
}